import { connect } from 'react-redux'

import InteractionListItem from '../../components/Dashboard/InteractionListItem'
import { fetchInteraction } from '../../ducks/interaction'

export default connect(
  ({ interaction }) => ({
    selectedInteractionId: interaction.selectedInteractionId
  }),
  { fetchInteraction }
)(InteractionListItem)
